var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVolumeOffOutline = function SvgVolumeOffOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.725 14.335a.5.5 0 0 1-.707.707l-2.309-2.31-2.31 2.31a.497.497 0 0 1-.706 0 .5.5 0 0 1 0-.707l2.309-2.31-2.312-2.312a.5.5 0 1 1 .707-.707l2.312 2.312 2.313-2.312a.5.5 0 1 1 .707.707l-2.313 2.312 2.31 2.31ZM11.6 17.27l-4.448-2.596a.5.5 0 0 0-.252-.068H3.125V9.394h3.774a.498.498 0 0 0 .252-.068L11.6 6.73v10.54Zm.75-11.845a.501.501 0 0 0-.502.002L6.764 8.394H2.625a.5.5 0 0 0-.5.5v6.212a.5.5 0 0 0 .5.5h4.139l5.083 2.967a.499.499 0 0 0 .753-.432V5.859a.5.5 0 0 0-.252-.434Z",
    fill: "currentColor"
  })));
};
export default SvgVolumeOffOutline;